import type { FilterAiOptions_Response } from '@zendesk/zqa-services/filters'
import { api } from '@/api'
import { session } from '@/composables/useSession'

export async function getAiFilterOptions(prompt: string): Promise<FilterAiOptions_Response> {
  await new Promise((resolve) => setTimeout(resolve, 1000))

  return api
    .post('filter/ai-options', {
      headers: { 'X-Klaus-Workspace': session.workspace.id.toString() },
      json: { prompt },
    })
    .json()
}
